import { IReduxStore } from "Redux/Store/IReduxStore";
import {
    DELETE_SPOT_REQUEST,
} from 'Redux/Action';
import { ArrayContains } from 'ClientService';

export const willBeDeleteSpot = (state: IReduxStore): boolean => ArrayContains(state.spot.openRequests, [
    DELETE_SPOT_REQUEST
]);